module.exports = __webpack_public_path__ + "static/media/bins.8ce107de.png";